import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme"; // 🟢 KHÔI PHỤC THEME GỐC BẢO VỆ NAVBAR
import { 
    Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, 
    Card, CardContent, Typography, Stack, Chip, Divider, CircularProgress, TableContainer, Grid
} from "@mui/material";
import { AccessTime, CasinoOutlined, RefreshOutlined, GroupOutlined, AutoFixHighOutlined } from "@mui/icons-material";
import axios from "axios";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import { t } from "i18next";
import { GetNameChoose } from "../../funcUtils";

// ==========================================
// THEME CHUẨN KÈM FONT PLUS JAKARTA SANS
// ==========================================
const metronicTheme = createTheme({
    palette: {
        background: { default: "#F5F8FA", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#7E8299" }, 
        primary: { main: "#1B84FF", light: "#F1FAFF" },
        success: { main: "#50CD89", light: "#E8FFF3" },
        danger: { main: "#F1416C", light: "#FFF5F8" },
        warning: { main: "#FFC700", light: "#FFF8DD" },
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: { styleOverrides: { root: { borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.03)", border: "1px solid #E4E6EF" } } },
        MuiTableCell: { styleOverrides: { root: { borderBottom: "1px solid #EFF2F5 !important", padding: "14px 12px", color: "#3F4254", fontSize: "0.85rem", fontFamily: "'Plus Jakarta Sans', sans-serif !important" } } },
        MuiButton: { styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif" } } }
    }
});

axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("user");
    if (token) config.headers["Authorization"] = `Bearer ${token}`;
    return config;
}, (error) => Promise.reject(error));

// ======================================================
// 🟢 ĐÃ ĐƯỢC ĐƯA RA NGOÀI ĐỂ KHẮC PHỤC LỖI VĂNG CON TRỎ CHUỘT
// ======================================================
const PrizeRow = ({ label, isSpecial, bgColor, children }) => (
    <Box sx={{ display: 'flex', borderBottom: '1px solid #EFF2F5', backgroundColor: bgColor || 'transparent' }}>
        <Box sx={{ 
            width: { xs: '65px', sm: '100px' }, 
            flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', 
            fontWeight: 800, borderRight: '1px solid #EFF2F5', p: 1, 
            color: isSpecial ? '#F1416C' : '#181C32',
            backgroundColor: isSpecial ? '#FFF5F8' : 'transparent',
            fontSize: { xs: '0.8rem', sm: '0.9rem' }
        }}>
            {label}
        </Box>
        <Box sx={{ 
            flex: 1, p: { xs: 1.5, sm: 2 }, 
            display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center', alignItems: 'center' 
        }}>
            {children}
        </Box>
    </Box>
);

function SetXoSo() {
    const [list30, setList30] = useState();
    const [bet, setBet] = useState(null);
    const [second, setSecond] = useState(15);
    const [minute, setMinute] = useState(1);
    const [start, setStart] = useState(false);
    const [dulieunhap, setDulieunhap] = useState(new Date());
    const [update, setUpdate] = useState(0);
    const [current, setCurrent] = useState(null);
    const [total, setTotal] = useState(null);
    const [listEdit, setListEdit] = useState();
    const [newChange, setNewChange] = useState();
    const [numbers, setNumbers] = useState(Array(27).fill(null));

    const date = new Date();
    const currentMinute = date.getMinutes();
    const currentSecond = date.getSeconds();

    function formatDate(m) {
        if (!m) return "";
        const d = new Date(m);
        return `${d.getUTCFullYear()}/${("0" + (d.getMonth() + 1)).slice(-2)}/${("0" + d.getDate()).slice(-2)}  ${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}`;
    }

    const reloadHistorySilently = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/xs75s/getadmin`).then((res) => {
            if (res.data?.data?.length > 0) setBet(res.data.data[0]);
        }).catch(() => {});
        axios.get(`${process.env.REACT_APP_API_URL}/xs75s/list30bet`).then((res) => setList30(res.data.data)).catch(() => setList30(null));
        axios.get(`${process.env.REACT_APP_API_URL}/xs75s/getcurrent`).then((res) => setCurrent(res.data.data)).catch(() => {});
    };

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/xs75s/getadmin`).then((res) => {
            if(res.data?.data?.[0]) {
                setBet(res.data.data[0]);
                setDulieunhap(new Date(res.data.data[0].createdAt));
                setStart(true);
            }
        });
        axios.get(`${process.env.REACT_APP_API_URL}/xs75s/getallbet`).then((res) => setTotal(res.data.data)).catch(() => setTotal(null));
        reloadHistorySilently();
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            if (Math.floor(75 - (new Date() - dulieunhap) / 1000) < 0) {
                axios.get(`${process.env.REACT_APP_API_URL}/xs75s/getadmin`).then((res) => {
                    if(res.data?.data?.[0]) {
                        setBet(res.data.data[0]);
                        setDulieunhap(new Date(res.data.data[0].createdAt));
                    }
                });
                axios.get(`${process.env.REACT_APP_API_URL}/xs75s/getallbet`).then((res) => setTotal(res.data.data)).catch(() => setTotal(null));
                reloadHistorySilently();
            }
        }, 500);
        return () => clearInterval(timer);
    }, [dulieunhap]);

    useEffect(() => {
        let curTime_second = Math.floor(75 - (date - dulieunhap) / 1000);
        let myTimeout;

        if (currentMinute === dulieunhap.getMinutes() && currentSecond === dulieunhap.getSeconds()) {
            setStart(true);
            setSecond(second - 1);
            return () => clearTimeout(myTimeout);
        } else if (curTime_second < 75 && curTime_second >= 0) {
            setSecond(curTime_second % 60);
            setMinute((curTime_second - (curTime_second % 60)) / 60);
            setStart(true);
            return () => clearTimeout(myTimeout);
        } else {
            myTimeout = setTimeout(() => setUpdate(update + 1), 500);
        }
    }, [update, dulieunhap]);

    useEffect(() => {
        let curTime_second = Math.floor(75 - (date - dulieunhap) / 1000);
        let myTimeout = 0;
        if (start) {
            setSecond(curTime_second % 60);
            setMinute(Math.floor(curTime_second / 60));
            if (curTime_second > 75 || curTime_second <= 0) {
                setStart(false);
                setMinute(1);
                setSecond(15);
                return () => clearTimeout(myTimeout);
            }
            myTimeout = setTimeout(() => {
                setSecond(second - 1);
                axios.get(`${process.env.REACT_APP_API_URL}/xs75s/getcurrent`).then((res) => setCurrent(res.data.data)).catch(() => setCurrent(null));
            }, 1000);
        }
        return () => clearTimeout(myTimeout);
    }, [second, start, dulieunhap]);

    const handleChange = (e) => {
        setListEdit(e.target.value);
        const a = list30?.find((item) => item?.id_bet === e.target.value);
        setNewChange(a);
        setNumbers(Array(27).fill(null)); 
    };

    const generateRandomNumbers = () => {
        const randomNumbers = Array(27).fill("").map((_, index) => {
            if (index < 10) return (Math.floor(Math.random() * 90000) + 10000).toString(); // 5 số
            if (index >= 10 && index < 20) return (Math.floor(Math.random() * 9000) + 1000).toString(); // 4 số
            if (index >= 20 && index < 23) return (Math.floor(Math.random() * 900) + 100).toString(); // 3 số
            return (Math.floor(Math.random() * 90) + 10).toString(); // 2 số
        });
        setNumbers(randomNumbers);
    };

    const handleInputChange = (event, index) => {
        const newValue = event.target.value;
        setNumbers((prev) => {
            const next = [...prev];
            next[index] = newValue;
            return next;
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = {
            id_bet: newChange ? newChange._id : bet._id,
            dacbiet: e.target.dacbiet.value,
            nhat: e.target.nhat.value,
            hai: e.target.hai1.value + " " + e.target.hai2.value,
            ba: e.target.ba1.value + " " + e.target.ba2.value + " " + e.target.ba3.value + " " + e.target.ba4.value + " " + e.target.ba5.value + " " + e.target.ba6.value,
            tu: e.target.tu1.value + " " + e.target.tu2.value + " " + e.target.tu3.value + " " + e.target.tu4.value,
            nam: e.target.nam1.value + " " + e.target.nam2.value + " " + e.target.nam3.value + " " + e.target.nam4.value + " " + e.target.nam5.value + " " + e.target.nam6.value,
            sau: e.target.sau1.value + " " + e.target.sau2.value + " " + e.target.sau3.value,
            bay: e.target.bay1.value + " " + e.target.bay2.value + " " + e.target.bay3.value + " " + e.target.bay4.value
        };
        
        axios.post(`${process.env.REACT_APP_API_URL}/xs75s/update`, formData)
            .then(() => { swal(t('success'), "Đã lưu kết quả thành công!", "success"); reloadHistorySilently(); })
            .catch(() => swal(t('error'), "Có lỗi xảy ra", "error"));
    };

    // 🟢 Hàm lấy giá trị input rất mượt, tránh lỗi bị dội ngược giá trị cũ khi xóa
    const getVal = (idx, defaultVal) => {
        return numbers[idx] !== null ? numbers[idx] : (defaultVal || "");
    };

    const isDangerTime = (minute === 0 && second <= 15);

    return (
        // 🟢 BỌC THEME GỐC Ở ĐÂY ĐỂ BẢO VỆ NAVBAR
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                
                {/* 🟢 BỌC THEME MỚI Ở TRONG ĐỂ LÀM ĐẸP GIAO DIỆN CHÍNH */}
                <ThemeProvider theme={metronicTheme}>
                    <style>{`
                        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                        .safe-xs-zone * { box-sizing: border-box; font-family: 'Plus Jakarta Sans', sans-serif !important; }
                        
                        /* CSS Responsive Form Xổ Số */
                        .xs-input {
                            width: 75px !important;
                            padding: 8px 4px !important;
                            text-align: center !important;
                            border: 1px solid #E4E6EF;
                            border-radius: 6px;
                            font-weight: 700;
                            color: #181C32;
                            outline: none;
                            transition: all 0.2s ease;
                        }
                        .xs-input:focus { border-color: #F1416C; box-shadow: 0 0 0 3px rgba(241, 65, 108, 0.1); }
                        .xs-input.special { color: #F1416C; font-size: 1.1rem; }

                        @media (max-width: 600px) {
                            .xs-input {
                                width: calc(33.33% - 6px) !important; /* Màn hình nhỏ sẽ chia làm 3 cột */
                                font-size: 0.8rem;
                            }
                            .xs-input.special { width: 100px !important; }
                        }
                    `}</style>

                    <Box className="safe-xs-zone" component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: 'background.default', minHeight: 'calc(100vh - 70px)' }}>
                        <Container maxWidth="xl">
                            
                            {/* HEADER */}
                            <Box mb={4} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
                                <Box>
                                    <Typography variant="h4" fontWeight="800" color="#181C32">XỔ SỐ 75S</Typography>
                                    <Typography variant="body2" color="text.secondary">Quản lý và can thiệp kết quả xổ số kiến thiết siêu tốc</Typography>
                                </Box>
                                <Button variant="outlined" startIcon={<RefreshOutlined />} onClick={() => window.location.reload()} sx={{ borderRadius: '8px', fontWeight: 700, textTransform: 'none' }}>
                                    Làm mới
                                </Button>
                            </Box>

                            <Grid container spacing={3} mb={4}>
                                
                                {/* BẢNG ĐIỀU KHIỂN & KẾT QUẢ XỔ SỐ */}
                                <Grid item xs={12} lg={7}>
                                    <Card sx={{ height: '100%', backgroundColor: '#FFFFFF' }}>
                                        <CardContent sx={{ p: {xs: 2, sm: 4} }}>
                                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3} flexWrap="wrap" gap={2}>
                                                <Typography variant="h6" fontWeight="800" color="#181C32" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <CasinoOutlined color="warning" /> Bảng Can Thiệp Kết Quả
                                                </Typography>
                                                
                                                <Box display="flex" alignItems="center" gap={2}>
                                                    <Typography variant="body2" fontWeight="700" color="text.secondary">Phiên:</Typography>
                                                    <select 
                                                        onChange={handleChange} 
                                                        value={listEdit || (bet ? bet.id_bet : "")} 
                                                        style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #E4E6EF', outline: 'none', fontWeight: 700, color: '#1B84FF', cursor: 'pointer' }}
                                                    >
                                                        {bet && <option value={bet.id_bet}>Hiện tại (#{bet.id_bet})</option>}
                                                        {list30?.map((item) => (
                                                            item.id_bet !== bet?.id_bet && <option key={item.id_bet} value={item.id_bet}>Lịch sử (#{item.id_bet})</option>
                                                        ))}
                                                    </select>
                                                </Box>
                                            </Box>

                                            <form onSubmit={handleSubmit}>
                                                <Box sx={{ border: '1px solid #EFF2F5', borderRadius: '12px', overflow: 'hidden', mb: 4 }}>
                                                    
                                                    {/* ĐÃ THAY BẰNG HÀM getVal() MƯỢT MÀ */}
                                                    <PrizeRow label="ĐB" isSpecial>
                                                        <input className="xs-input special" min="10000" max="99999" name="dacbiet" value={getVal(0, (newChange || bet)?.dacbiet)} onChange={(e) => handleInputChange(e, 0)} />
                                                    </PrizeRow>
                                                    
                                                    <PrizeRow label="Giải 1">
                                                        <input className="xs-input" name="nhat" min="10000" max="99999" value={getVal(1, (newChange || bet)?.nhat)} onChange={(e) => handleInputChange(e, 1)} />
                                                    </PrizeRow>
                                                    
                                                    <PrizeRow label="Giải 2" bgColor="#F9F9F9">
                                                        <input className="xs-input" name="hai1" min="10000" max="99999" value={getVal(2, (newChange || bet)?.hai?.split(" ")[0])} onChange={(e) => handleInputChange(e, 2)} />
                                                        <input className="xs-input" name="hai2" min="10000" max="99999" value={getVal(3, (newChange || bet)?.hai?.split(" ")[1])} onChange={(e) => handleInputChange(e, 3)} />
                                                    </PrizeRow>
                                                    
                                                    <PrizeRow label="Giải 3">
                                                        <input className="xs-input" min="10000" max="99999" name="ba1" value={getVal(4, (newChange || bet)?.ba?.split(" ")[0])} onChange={(e) => handleInputChange(e, 4)} />
                                                        <input className="xs-input" min="10000" max="99999" name="ba2" value={getVal(5, (newChange || bet)?.ba?.split(" ")[1])} onChange={(e) => handleInputChange(e, 5)} />
                                                        <input className="xs-input" min="10000" max="99999" name="ba3" value={getVal(6, (newChange || bet)?.ba?.split(" ")[2])} onChange={(e) => handleInputChange(e, 6)} />
                                                        <input className="xs-input" min="10000" max="99999" name="ba4" value={getVal(7, (newChange || bet)?.ba?.split(" ")[3])} onChange={(e) => handleInputChange(e, 7)} />
                                                        <input className="xs-input" min="10000" max="99999" name="ba5" value={getVal(8, (newChange || bet)?.ba?.split(" ")[4])} onChange={(e) => handleInputChange(e, 8)} />
                                                        <input className="xs-input" min="10000" max="99999" name="ba6" value={getVal(9, (newChange || bet)?.ba?.split(" ")[5])} onChange={(e) => handleInputChange(e, 9)} />
                                                    </PrizeRow>

                                                    <PrizeRow label="Giải 4" bgColor="#F9F9F9">
                                                        <input className="xs-input" min="1000" max="9999" name="tu1" value={getVal(10, (newChange || bet)?.tu?.split(" ")[0])} onChange={(e) => handleInputChange(e, 10)} />
                                                        <input className="xs-input" min="1000" max="9999" name="tu2" value={getVal(11, (newChange || bet)?.tu?.split(" ")[1])} onChange={(e) => handleInputChange(e, 11)} />
                                                        <input className="xs-input" min="1000" max="9999" name="tu3" value={getVal(12, (newChange || bet)?.tu?.split(" ")[2])} onChange={(e) => handleInputChange(e, 12)} />
                                                        <input className="xs-input" min="1000" max="9999" name="tu4" value={getVal(13, (newChange || bet)?.tu?.split(" ")[3])} onChange={(e) => handleInputChange(e, 13)} />
                                                    </PrizeRow>

                                                    <PrizeRow label="Giải 5">
                                                        <input className="xs-input" min="1000" max="9999" name="nam1" value={getVal(14, (newChange || bet)?.nam?.split(" ")[0])} onChange={(e) => handleInputChange(e, 14)} />
                                                        <input className="xs-input" min="1000" max="9999" name="nam2" value={getVal(15, (newChange || bet)?.nam?.split(" ")[1])} onChange={(e) => handleInputChange(e, 15)} />
                                                        <input className="xs-input" min="1000" max="9999" name="nam3" value={getVal(16, (newChange || bet)?.nam?.split(" ")[2])} onChange={(e) => handleInputChange(e, 16)} />
                                                        <input className="xs-input" min="1000" max="9999" name="nam4" value={getVal(17, (newChange || bet)?.nam?.split(" ")[3])} onChange={(e) => handleInputChange(e, 17)} />
                                                        <input className="xs-input" min="1000" max="9999" name="nam5" value={getVal(18, (newChange || bet)?.nam?.split(" ")[4])} onChange={(e) => handleInputChange(e, 18)} />
                                                        <input className="xs-input" min="1000" max="9999" name="nam6" value={getVal(19, (newChange || bet)?.nam?.split(" ")[5])} onChange={(e) => handleInputChange(e, 19)} />
                                                    </PrizeRow>

                                                    <PrizeRow label="Giải 6" bgColor="#F9F9F9">
                                                        <input className="xs-input" min="100" max="999" name="sau1" value={getVal(20, (newChange || bet)?.sau?.split(" ")[0])} onChange={(e) => handleInputChange(e, 20)} />
                                                        <input className="xs-input" min="100" max="999" name="sau2" value={getVal(21, (newChange || bet)?.sau?.split(" ")[1])} onChange={(e) => handleInputChange(e, 21)} />
                                                        <input className="xs-input" min="100" max="999" name="sau3" value={getVal(22, (newChange || bet)?.sau?.split(" ")[2])} onChange={(e) => handleInputChange(e, 22)} />
                                                    </PrizeRow>

                                                    <PrizeRow label="Giải 7">
                                                        <input className="xs-input" min="10" max="99" name="bay1" value={getVal(23, (newChange || bet)?.bay?.split(" ")[0])} onChange={(e) => handleInputChange(e, 23)} />
                                                        <input className="xs-input" min="10" max="99" name="bay2" value={getVal(24, (newChange || bet)?.bay?.split(" ")[1])} onChange={(e) => handleInputChange(e, 24)} />
                                                        <input className="xs-input" min="10" max="99" name="bay3" value={getVal(25, (newChange || bet)?.bay?.split(" ")[2])} onChange={(e) => handleInputChange(e, 25)} />
                                                        <input className="xs-input" min="10" max="99" name="bay4" value={getVal(26, (newChange || bet)?.bay?.split(" ")[3])} onChange={(e) => handleInputChange(e, 26)} />
                                                    </PrizeRow>
                                                </Box>

                                                <Stack direction="row" spacing={2} justifyContent="center">
                                                    <Button 
                                                        variant="outlined" 
                                                        color="primary" 
                                                        startIcon={<AutoFixHighOutlined />}
                                                        onClick={generateRandomNumbers}
                                                        sx={{ fontWeight: 800, borderRadius: '8px', px: {xs: 2, sm: 4}, textTransform: 'none' }}
                                                    >
                                                        Quay Ngẫu Nhiên
                                                    </Button>
                                                    <Button 
                                                        type="submit" 
                                                        variant="contained" 
                                                        color="success" 
                                                        sx={{ fontWeight: 800, borderRadius: '8px', px: {xs: 3, sm: 6}, boxShadow: 'none' }}
                                                    >
                                                        LƯU KẾT QUẢ
                                                    </Button>
                                                </Stack>
                                            </form>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* PANEL PHẢI: TRẠNG THÁI & NGƯỜI CHƠI CƯỢC */}
                                <Grid item xs={12} lg={5}>
                                    <Card sx={{ border: '1px solid #E4E6EF', backgroundColor: '#FFFFFF', mb: 3 }}>
                                        <CardContent sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <Typography variant="caption" fontWeight="800" color="#A1A5B7" sx={{ textTransform: 'uppercase', letterSpacing: '1px', mb: 2 }}>Trạng thái vòng quay</Typography>
                                            
                                            <Box sx={{ 
                                                width: '200px', height: '200px', borderRadius: '50%', 
                                                border: `10px solid ${isDangerTime ? '#F1416C' : '#1B84FF'}`,
                                                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                                                boxShadow: isDangerTime ? '0 0 30px rgba(241, 65, 108, 0.4)' : '0 0 30px rgba(27, 132, 255, 0.2)',
                                                transition: 'all 0.5s ease', mb: 3
                                            }}>
                                                <Typography variant="h2" fontWeight="900" color={isDangerTime ? '#F1416C' : '#1B84FF'} sx={{ lineHeight: 1 }}>
                                                    {minute}:{second < 10 ? `0${second}` : second}
                                                </Typography>
                                            </Box>
                                            
                                            <Typography variant="h6" fontWeight="800" color="#181C32">Kỳ số: #{bet ? bet.id_bet : 'Đang tải'}</Typography>
                                            <Typography variant="body2" color="text.secondary">{(listEdit || (bet && bet.id_bet)) !== (bet && bet.id_bet) ? "(Đang xem lịch sử)" : "(Đang chạy trực tiếp)"}</Typography>
                                        </CardContent>
                                    </Card>

                                    {/* BẢNG DANH SÁCH NGƯỜI CHƠI ĐANG CƯỢC */}
                                    <Card sx={{ backgroundColor: '#FFFFFF' }}>
                                        <Box sx={{ p: 2.5, borderBottom: '1px solid #EFF2F5', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography variant="h6" fontWeight="800" color="#181C32" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <GroupOutlined color="primary" /> Đơn Cược Kỳ Này
                                            </Typography>
                                            <Chip label={`Tổng: ${current ? current.length : 0}`} size="small" sx={{ backgroundColor: '#F1FAFF', color: '#1B84FF', fontWeight: 800 }} />
                                        </Box>
                                        <TableContainer sx={{ overflowX: 'auto', maxHeight: '450px' }}>
                                            <Table stickyHeader>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', backgroundColor: '#FFFFFF' }}>TÀI KHOẢN</TableCell>
                                                        <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', backgroundColor: '#FFFFFF' }}>CỬA CƯỢC</TableCell>
                                                        <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', backgroundColor: '#FFFFFF' }}>TIỀN CƯỢC</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {current && current.length > 0 ? current.map((item, idx) => (
                                                        <TableRow key={idx} hover>
                                                            <TableCell>
                                                                <Typography variant="body2" fontWeight="800" color="#2563EB">{item?.user?.username || 'Ẩn danh'}</Typography>
                                                                <Typography variant="caption" fontWeight="600" color="text.secondary">ID: {item?.user?.iduser || 'N/A'}</Typography>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Typography variant="body2" fontWeight="700" color="#181C32">
                                                                    {GetNameChoose(item.state, item.type) || item.state}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Typography variant="body2" fontWeight="800" color="#16A34A">
                                                                    {Number(item.money).toLocaleString("vi-VN")} đ
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    )) : (
                                                        <TableRow>
                                                            <TableCell colSpan={3} align="center" sx={{ py: 6, color: '#A1A5B7', fontWeight: 600 }}>
                                                                Chưa có người chơi cược
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Card>
                                </Grid>
                            </Grid>

                        </Container>
                    </Box>
                </ThemeProvider>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default SetXoSo;